//Primer objetivo cargar la data:
import * as React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import ListaVerificacionService from "../../services/listaVerificacionService";
import {
  IItemListaVerificacion,
  IDetalleListaVerificacion,
  IDetalleListaVerificacionItem,
  IRevisionListaVerificacion,
} from "../../Interfaces/IListaVerificacion";
import { Separator } from "@fluentui/react/lib/Separator";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  DetailsListLayoutMode,
  Selection,
  IColumn,
} from "@fluentui/react/lib/DetailsList";
import { Text } from "@fluentui/react/lib/Text";
import {
  mergeStyleSets,
  getTheme,
  concatStyleSets,
} from "@fluentui/react/lib/Styling";
import {
  ICommandBarItemProps,
  IContextualMenuItemStyles,
  IContextualMenuStyles,
  ContextualMenuItem,
  IContextualMenuItemProps,
  Modal,
  TooltipHost,
  Stack,
  DatePicker,
  defaultDatePickerStrings,
  ComboBox,
  IComboBox,
  IComboBoxOption,
  Pivot,
  PivotItem,
} from "@fluentui/react";

import {
  CommandBarButton,
  IButtonProps,
  IButtonStyles,
} from "@fluentui/react/lib/Button";
import { Panel, PanelType } from "@fluentui/react/lib/Panel";

import { IObjectWithKey, memoizeFunction } from "@fluentui/react/lib/Utilities";
import { useBoolean } from "@fluentui/react-hooks";
import {
  ChoiceGroup,
  IChoiceGroupOption,
} from "@fluentui/react/lib/ChoiceGroup";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Icon } from "@fluentui/react/lib/Icon";
import { Image, ImageFit } from "@fluentui/react/lib/Image";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import { HeadingBar } from "../../components/generic/HeadingBar";
import {
  baseSearch,
  _initialFilter,
  _initialPagination,
} from "../../utils/helpers/helpers";
import { PanelGenerico } from "../../components/generic/PanelGenerico";
import { IItemComboBaseDTO } from "../../Interfaces/base/IBase";
import themeBase from "../../utils/theme/themeBase";
import { useSearchParams } from "react-router-dom";
import { _formatDate, formatDate_DDMMYY, getPrimerDiaDelMes, ObtenerFechaSegunLugar } from "../../utils/helpers/dateHelpers";
import BaseTelelirk, {
  ETelerikViewmode,
} from "../../components/generic/baseTelerik";
import { IPagination } from "../../Interfaces/base/ITable";
import { IHeaderTitlesText, IpanelGeneric } from "../../Interfaces/IPanel";
import FilterMantenimiento, {
  IFilterChecklistMantenimiento,
} from "./Mantenimiento/FilterMantenimiento";
import { Ifilter } from "../../Interfaces/filter";
import { TableBase } from "../../components/Table/TableBase";
import Estado from "../../components/elements/Estado";
import PersonaTag from "../../components/elements/Persona";
import IconHelper from "../../utils/helpers/iconHelper";
import COLORES from "../../utils/theme/colores";
import personaServicio from "../../services/persona/personaServicio";
import { useComboModelos } from "../../hooks/combosHooks/useComboModelos";
import { ComboBoxIDS } from "../../components/generic/ComboBoxIDS";
import FotosMantenimiento from "./FotosMantenimiento";
import { IComboBoxOptionPersonalizado } from "../iperc/historial/AdminHistorialIperc/reporte/ReporteGeneralIperc";
// import BaseTelerikV1 from "../../components/generic/baseTelerikV1";
import { TelerikMantenimiento } from "./telerikMantenimiento";
import { BaseTelerikV1, EViewMode } from "../../components/generic/baseTelerikV1";
import { PanelFooter } from "../../components/Panel/PanelFooter";
import { PanelHeader } from "../../components/Panel/PanelHeader";

function ListaVerificacionMantenimiento() {
  //const items: IDocument[] = [];
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const[control, setControl]= useState(false)
  const [hideDialogSuccess, { toggle: toggleHideDialogSuccess }] =
    useBoolean(true);
  const [hideDialogError, { toggle: toggleHideDialogError }] = useBoolean(true);
  var ListaVerificacionId: string[] = [];
  var dataFormRevision: IRevisionListaVerificacion = {
    ListaVerificacionId: [],
    InspeccionRadial: false,
    Taller: true,
    Comentario: "",
  };
  const data: IItemListaVerificacion[] = [];
  const dataRevision: IItemListaVerificacion[] = [];
  const itemDataRevision: IItemListaVerificacion = {
    listaVerificacionId: "",
    equipo: "",
    estado: "",
    fecha: "",
    nroDOI: "",
    persona: "",
    modelo: "",
    observacion: 0,
    guardia: "",
    comentario: "",
    observaciones: 0,
    observacionesCriticas: 0,
    cantidadFotos: 0,
    fotos: [],
  };
  const itemArray: IObjectWithKey[] = [];
  const detalleObservacionArray: IDetalleListaVerificacionItem[] = [];
  const detalleListaVerificacion: IDetalleListaVerificacion = {
    listaVerificacionId: "",
    persona: "",
    equipo: "",
    fecha: "",
    comentario: "",
    estado: "",
    codigoEstado: 0,
    fotos: [],
    observaciones: [],
    detalles: [],
  };
  const [formRevision, setFormRevision] = useState(dataFormRevision);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState(data);
  const [itemsMX, setItemsMx] = useState(data);
  //const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
  //useBoolean(false);

  /**TAGS */
  const [choice, setChoice] = React.useState<string | undefined>(undefined);
  const resetChoice = React.useCallback(() => {
    setChoice(undefined);
  }, []);

  const [openPanel, setOpenPanel] = useState(false);
  const [itemSeleccionados, setItemSeleccionados] = useState(itemArray);

  const [itemRevision, setItemRevision] = useState(itemDataRevision);
  const [itemsRevision, setItemsRevision] = useState(dataRevision);
  const [itemDetalleListaVerificacion, setItemDetalleListaVerificacion] =
    useState(detalleListaVerificacion);

  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [inputComentario, setInputComentario] = useState("");

  /**SI DATA DE TABLA ESTA CARGADA*/
  const [dataIsLoad, setDataIsLoad] = useState(false);

  const [tabIndex, setTabIndex] = useState("1");
  const [filter, setFilter] = useState<Ifilter>({
    skip: 0,
    take: 50,
    search: "",
  });
  const [isFilter, setisFilter] = useState(false);

  /**FILTERS */
  const [searchParam, setSearchParam] = useSearchParams();
  // const [filterAvanzado, setFilterAvanzado] = useState<IFilterChecklistMantenimiento | undefined>({ SoloCriticas: true });
  /**FILTRO MODELOS */

  const [filterEquipos, setFilterEquipos] = useState<Ifilter>({
    skip: 0,
    take: 100,
    search: "",
  });

  const [filterTipoEquipo, setFilterTipoEquipo] =
    useState<Ifilter>(
      {
        skip: 0,
        take: 50,
        search: "",
      }
    );

  const [SupervisoresCombo, setSupervisoresCombo] = useState<
    IComboBoxOptionPersonalizado[]
  >([]);

  /**PanelFiltros*/
  const [modelInForm, setModelInForm] = useState<
    IFilterChecklistMantenimiento | undefined
  >({ SoloCriticas: true });
  const [isOpenFiltros, { setTrue: openFiltros, setFalse: dismissFiltros }] =
    useBoolean(false);
  const [isFilterMantenimiento, setisFilterMantenimiento] = useState(false);

  const mesActual = getPrimerDiaDelMes();

  const [filterMxBody, setFiltermxBody] = useState<
    IFilterPendienteMx | undefined
  >({
    fecha: _formatDate(ObtenerFechaSegunLugar(), "/"),
    fechaFin: _formatDate(ObtenerFechaSegunLugar(), "/"),
  });
  const [filterMx, setFiltermx] = useState<Ifilter>({
    skip: 0,
    take: 50,
    search: null,
  });
  const [
    isOpenFiltrosMx,
    { setTrue: openFiltrosMx, setFalse: dismissFiltrosMx },
  ] = useBoolean(false);
  const [isFilterMx, setisFilterMx] = useState(false);
  const comboBoxRefSupervisores = useRef<IComboBox>(null);
  const comboBoxRefTipoEquipo = useRef<IComboBox>(null);
  const comboBoxRefEquipo = useRef<IComboBox>(null);

  const [Search, setSearch] = useState("");
  const controllerRef = useRef<AbortController>(new AbortController());
  const controllerRefEquipos = useRef<AbortController>(new AbortController());
  const controllerRefTipoEquipo = useRef<AbortController>(new AbortController());

  /**Fechas de filtro */
  const [fechaInicio, setFechaInicio] = useState<Date | undefined>(ObtenerFechaSegunLugar());
  const [fechaFin, setFechaFin] = useState<Date | undefined>(ObtenerFechaSegunLugar());
  const [tipoEquipo, setTipoEquipo] = useState<IItemComboBaseDTO[]>([]);
  const [equipos, setEquipos] = useState<IItemComboBaseDTO[]>([]);
  const [estados, setEstados] = useState<IItemComboBaseDTO[]>([]);

  /**Adjunto Pdf*/
  const [isOpenAdjunto, { setTrue: openAdjunto, setFalse: dismissAdjunto }] =
    useBoolean(false);
  // FOTOS CHECKLIST
  const [
    isOpenFotosChecklist,
    { setTrue: openFotosChecklist, setFalse: dismissFotosChecklist },
  ] = useBoolean(false);
  const [fotosRutas, setFotosRutas] = useState<string[]>([]);

  /** ITEM DE TABLA */
  const [itemSelect, setItemSelect] = useState<IItemListaVerificacion>();

  /* Pagination MX*/
  const [currentPage, setCurrentPage] = useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
  const [total, setTotal] = useState(_initialPagination().total);

  const [pagIngreso, setPagIngreso] = useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => setCurrentPage(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  /* Pagination mantenimiento*/
  const [currentPage2, setCurrentPage2] = useState(
    _initialPagination().currentPage
  );
  const [pageSize2, setPageSize2] = useState(_initialPagination().pageSize);
  const [total2, setTotal2] = useState(_initialPagination().total);

  const filterMantenimientoRef = useRef(null);

  const [limpiarPanelMantenimiento, setLimpiarPanelMantenimiento] = useState(false);

  const actual = new Date();

  const [pagIngreso2, setPagIngreso2] = useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (pageMx) => setCurrentPage2(pageMx),
    onSizeChange: (pageSizeMx) => setPageSize2(pageSizeMx),
  });

  /* Hook Pagination */
  useEffect(() => {
    setPagIngreso({ ...pagIngreso, onSizeChange: () => setPageSize(pageSize) });
  }, [pageSize]);

  useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      currentPage: currentPage,
    });

    /* Solo si no es la primera carga actualiza el paginador */
    if (currentPage >= 1) {
      if (filter) {
        setFilter({
          ...filter,
          skip: (currentPage - 1) * pageSize,
          take: pageSize,
        });
      }
    }
  }, [currentPage]);

  useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      total: total,
    });
  }, [total]);

  /* Hook Pagination */
  useEffect(() => {
    setPagIngreso2({
      ...pagIngreso2,
      currentPage: currentPage2,
    });

    /* Solo si no es la primera carga actualiza el paginador */
    if (currentPage2 >= 1) {
      if (filterMx) {
        setFiltermx({
          ...filterMx,
          skip: (currentPage2 - 1) * pageSize2,
          take: pageSize2,
        });
      }
    }
  }, [currentPage2]);

  useEffect(() => {
    setPagIngreso2({
      ...pagIngreso2,
      total: total2,
    });
  }, [total2]);

  useEffect(() => {
    isOnFilterMantenimiento();
  }, [isOpenFiltros]);

  useEffect(() => {
    isfilterMxText();
  }, [isOpenFiltrosMx]);

  const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
      padding: 0,
      fontSize: "16px",
    },
    fileIconCell: {
      textAlign: "center",
      selectors: {
        "&:before": {
          content: ".",
          display: "inline-block",
          verticalAlign: "middle",
          height: "100%",
          width: "0px",
          visibility: "hidden",
        },
      },
    },
    fileIconImg: {
      verticalAlign: "middle",
      maxHeight: "16px",
      maxWidth: "16px",
    },
    controlWrapper: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
    },
    exampleToggle: {
      display: "inline-block",
      marginBottom: "10px",
      marginRight: "30px",
    },
    selectionDetails: {
      marginBottom: "20px",
    },
  });

  const [itemDetalleObservacionArray, setItemDetalleObservacionArray] =
    useState(detalleObservacionArray);

  const _columns: IColumn[] = [
    // {
    //   key: "tipoequipo",
    //   name: "Tipo Equipo",
    //   fieldName: "tipoEquipo",
    //   minWidth: 70,
    //   maxWidth: 100,
    //   isResizable: true,
    // },
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "modelo",
      minWidth: 150,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fecha",
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
      // onRender: (item: IItemListaVerificacion) => (<Fecha vertical value={item.fecha} tipo={RenderDateType.large} />)
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <Estado value={item.estado} />
      ),
    },
    // {
    //   key: "nroDOI",
    //   name: "DNI",
    //   fieldName: "nroDOI",
    //   minWidth: 65,
    //   maxWidth: 65,
    //   isResizable: true,
    //   isSorted: true,
    //   isSortedDescending: true,
    //   isRowHeader: true,
    //   flexGrow: 1,
    // },
    {
      key: "operador",
      name: "Operador",
      fieldName: "operador",
      minWidth: 150,
      maxWidth: 180,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <PersonaTag text={item.persona} nroDoi={item.nroDOI}></PersonaTag>
        // <Persona
        //   imageInitials={item.persona.substring(0, 1)}
        //   text={`${textoCadaPalabraMayuscula(item.persona)}`}
        //   secondaryText={`DNI : ${item.nroDOI}`}
        //   tertiaryText={`${item.nroDOI}`}
        //   size={PersonaSize.size8}
        //   showSecondaryText={true}
        // styles={{ primaryText: { fontSize: "0.68rem" }, secondaryText: { fontSize: "0.68rem" } }}
        // hidePersonaDetails={false}
        // />
      ),
    },
    {
      key: "supervisor",
      name: "Supervisor",
      fieldName: "supervisor",
      minWidth: 150,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "comentario",
      name: "Comentario",
      fieldName: "comentario",
      minWidth: 70,
      maxWidth: 80,
      // isResizable: true,
      // isMultiline: true,
      onRender: (item: IItemListaVerificacion) => (
        <>
          {item.comentario !== "" ? (
            <TooltipHost content={item.comentario}>
              <Icon
                iconName="CommentSolid"
                className="ms-fontSize-16"
                style={{ color: "#bebbb8" }}
              />
            </TooltipHost>
          ) : (
            <TooltipHost content="">
              <Icon
                iconName="Comment"
                className="ms-fontSize-16"
                style={{ color: "#bebbb8" }}
              />
            </TooltipHost>
          )}
        </>
      ),
    },
    {
      key: "observaciones",
      name: "Obs.",
      fieldName: "observaciones",
      minWidth: 30,
      maxWidth: 30,
      isResizable: true,
    },
    {
      key: "observacionesCriticas",
      name: "Obs. Críticas",
      fieldName: "observacionesCriticas",
      minWidth: 60,
      maxWidth: 60,
      isResizable: true,
    },
    {
      key: "fotos",
      name: "Fotos",
      fieldName: "cantidadFotos",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      onRender(item: IItemListaVerificacion, index?, column?) {
        if (item.cantidadFotos > 0) {
          return (
            <Icon
              iconName="PhotoCollection"
              className="ms-fontSize-16 "
              style={{
                cursor: "pointer",
                color: COLORES.Bases.neutralSecondaryAlt,
              }}
              onClick={() => {
                setFotosRutas(item.fotos);
                openFotosChecklist();
              }}
            />
          );
        }
      },
    },
    {
      key: "archivo",
      name: "Archivo",
      fieldName: "listaVerificacionId",
      minWidth: 50,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <TooltipHost content={"Ver Adjunto"}>
          <Icon
            iconName="PDF"
            className="ms-fontSize-16"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => {
              setItemSelect(item);
              openAdjunto();
            }}
          />
        </TooltipHost>
      ),
    },
  ];

  const _selection = new Selection({
    onSelectionChanged: () => {
      setItemSeleccionados(_selection.getSelection());
    },
  });

  function loadTabla(filters: Ifilter, body: any) {
    setItems([]);
    setDataIsLoad(false);
    ListaVerificacionService.getTabla(filter, body)
      .then((x) => {
        setItems(x.data.items);
        setTotal(x.data.total);
        setDataIsLoad(true);
      })
      .catch((e: Error) => {
        console.log(e.message);
        setDataIsLoad(true);
      });
    setDataIsLoad(false);
  }

  function loadTablaMx(filter: Ifilter, body: any) {
    let auxBody = {
      ...filter,
      ...body,
    };
    setItemsMx([]);
    setDataIsLoad(false);
    ListaVerificacionService.postTablaHistorialMX({ ...auxBody }).then((x) => {
      setItemsMx(x.data.items);
      setTotal2(x.data.total);
      setDataIsLoad(true);
    });
  }

  useEffect(() => {
    if (isOpenFiltrosMx) {
      ComboSupervisores();
      dataEstados();
      dataEquipos(filterEquipos);
      dataTipoEquipos(filterTipoEquipo);
    }
    isfilterMxText();

    // if (!isOpenFiltrosMx) {
    //   loadTablaMx(filterMx, filterMxBody);
    // }
  }, [isOpenFiltrosMx]);

  useEffect(() => {
    // if (filter.search != '')
    loadTabla(filter, { SoloCriticas: true });
  }, [filter.search]);

  useEffect(() => {
    loadTabla(filter, modelInForm);
  }, [filter.skip]);

  // Mx filter HOOKS
  useEffect(() => {
    // if (filterMx.search != '')
    loadTablaMx(filterMx, filterMxBody);
  }, [filterMx.search]);

  useEffect(() => {
    loadTablaMx(filterMx, filterMxBody);
  }, [filterMx.skip]);

  useEffect(() => {
    if (fechaInicio != undefined && fechaFin != undefined) {
      setFiltermxBody({
        ...filterMxBody,
        fecha: formatDate_DDMMYY(fechaInicio),
        fechaFin: formatDate_DDMMYY(fechaFin),
      });
    }

    if (fechaInicio != undefined && fechaInicio > (fechaFin as Date)) {
      setFechaFin(fechaInicio);
    }
  }, [fechaInicio, fechaFin]);

  const dataEquipos = (filterEquipos: any) => {
    controllerRefEquipos.current.abort();
    const newController = new AbortController();
    controllerRefEquipos.current = newController;
    
    ListaVerificacionService.listaEquipos(filterEquipos, newController)
      .then((res) => {
        setEquipos(res.data);
      })
      .catch((e) => {
        console.log(e.message);
      });
  };
  const dataTipoEquipos = (filter: any) => {
    // Cancelar petición anterior y crear nuevo controller
    controllerRefTipoEquipo.current.abort();
    const newController = new AbortController();
    controllerRefTipoEquipo.current = newController;
    
    ListaVerificacionService.listaTipoEquipos(filter, newController)
      .then((res) => {
        setTipoEquipo(res.data);
      })
      .catch((e) => {
        console.log( e.message);
      });
  };
  const dataEstados = () => {
    ListaVerificacionService.listaEstados()
      .then((res) => {
        // console.log(res.data)
        setEstados(res.data);
      })
      .catch((e) => {
        console.log(e.message);
      });
  };
  const ComboSupervisores = (search: string = "") => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    personaServicio
      .getSupervisoresCombo(search, newController)
      .then((arg) => {
        let d: any[] = arg.data;
        // let op: IComboBoxOption[] = [];
        // d.map((x) => {
        //   op.push({
        //     key: x.supervisorId,
        //     text: x.persona,
        //   });
        // });
        setSupervisoresCombo(d);
      })
      .catch((e: Error) => {
        console.log(e.message);
      });
  };

  const isfilterMxText = () => {
    if (filterMxBody)
      filterMxBody.equipoId ||
        filterMxBody.equipoModeloId ||
        filterMxBody.fecha ||
        filterMxBody.fechaFin ||
        filterMxBody.supervisorId ||
        filterMxBody.tipoEquipoId
        ? setisFilterMx(true)
        : setisFilterMx(false);
  };

  const _onChangeEqipos = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        // setFilterAvanzado({
        //   ...filterAvanzado,
        //   equipoId: option.key.toString(),
        // })
        setFiltermxBody({
          ...filterMxBody,
          equipoId: option.key.toString(),
        });
      }
    }
  };

  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
    limpiarFilters: limpiarFiltersModelos,
  } = useComboModelos();

  const _onChangeModelos = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setFiltermxBody({
          ...filterMxBody,
          equipoModeloId: option.key.toString(),
        });
      }
    }
  };
  const _onChangeTipoEquipo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setFiltermxBody({
          ...filterMxBody,
          tipoEquipoId: option.key.toString(),
        });
      }
    }
  };
  const _onChangeSupervisor = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event !== undefined) {
      if (option !== undefined) {
        console.log(option.key);
        setFiltermxBody({
          ...filterMxBody,
          supervisorId: option.key.toString(),
        });
      }
    }
  };

  interface IExampleProps {
    resetChoice?: () => void;
  }

  const color = "";

  const theme = getTheme();
  const itemStyles: Partial<IContextualMenuItemStyles> = {
    label: { fontSize: 13 },
    icon: { color: theme.palette.blue },
    iconHovered: { color: theme.palette.blueDark },
  };

  const menuStyles: Partial<IContextualMenuStyles> = {
    subComponentStyles: { menuItem: itemStyles, callout: {} },
  };

  const getCommandBarButtonStyles = memoizeFunction(
    (
      originalStyles: IButtonStyles | undefined
    ): Partial<IContextualMenuItemStyles> => {
      if (!originalStyles) {
        return itemStyles;
      }

      return concatStyleSets(originalStyles, itemStyles);
    }
  );

  const CustomButton: React.FunctionComponent<IButtonProps> = (props) => {
    const buttonOnMouseClick = () => alert(`${props.text} clicked`);
    // eslint-disable-next-line react/jsx-no-bind
    return (
      <CommandBarButton
        {...props}
        //onClick={buttonOnMouseClick}
        styles={getCommandBarButtonStyles(props.styles)}
      />
    );
  };

  const onRenderHeaderMantenimiento = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Mantenimiento"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Pendiente Sup. Mantto"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );
  // Custom renderer for menu items (these must have a separate custom renderer because it's unlikely
  // that the same component could be rendered properly as both a command bar item and menu item).
  // It's also okay to custom render only the command bar items without changing the menu items.
  const CustomMenuItem: React.FunctionComponent<IContextualMenuItemProps> = (
    props
  ) => {
    // Due to ContextualMenu implementation quirks, passing styles or onClick here doesn't work.
    // The onClick handler must be on the ICommandBarItemProps item instead (_overflowItems in this example).
    return <ContextualMenuItem {...props} />;
  };

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => loadTablaMx(filterMx, filterMxBody),
    },
    {
      key: "revisar",
      text: "Revisar",
      iconProps: { iconName: "CheckMark" },
      onClick: () => {
        if (itemSeleccionados.length > 0) {
          setOpenPanel(true);
          //traer detalle si es uno caso contrario listar de la selección:
          if (itemSeleccionados.length === 1) {
            var valor = itemSeleccionados[0] as IItemListaVerificacion;
            //itemRevision.listaVerificacionId = valor.listaVerificacionId;
            setItemRevision(valor);
            setItemsRevision(dataRevision);
            ListaVerificacionService.getDetalle(valor.listaVerificacionId).then(
              (x) => {
                setItemDetalleListaVerificacion(x.data);
              }
            );
          } else {
            var valores = itemSeleccionados as IItemListaVerificacion[];
            //itemsRevision
            setItemRevision(itemDataRevision);
            setItemsRevision(valores);
            setItemDetalleListaVerificacion(detalleListaVerificacion);
          }
        } else {
          setItemRevision(itemDataRevision);
          setItemsRevision(dataRevision);
        }
      },
    },
  ];

  const _itemsMantto: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => loadTabla(filter, { SoloCriticas: true }),
    },
  ];

  const optionsActividad: IChoiceGroupOption[] = [
    {
      key: "trabajo",
      text: "Trabajo",
      iconProps: { iconName: "Accept" },
      styles: { root: { color: theme.palette.greenDark } },
      onClick: () => {
        formRevision.Taller = false;
      },
    },
    {
      key: "taller",
      text: "Taller",
      color: theme.palette.red,
      iconProps: { iconName: "Cancel", color: theme.palette.red },
      styles: { root: { color: theme.palette.yellowDark } },
      onClick: () => {
        formRevision.Taller = true;
      },
    },
  ];

  const optionsInspeccion: IChoiceGroupOption[] = [
    {
      key: "no",
      text: "Sin Inspección",
      iconProps: { iconName: "Cancel" },
      styles: { root: { color: theme.palette.yellowDark } },
      onClick: () => {
        formRevision.InspeccionRadial = false;
      },
    },
    {
      key: "radial",
      text: "Radial",
      color: theme.palette.red,
      iconProps: { iconName: "TransferCall" },
      styles: { root: { color: theme.palette.greenDark } },
      onClick: () => {
        formRevision.InspeccionRadial = true;
      },
    },
  ];

  const buttonStyles = { root: { marginRight: 8 } };
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={() => {
            toggleHideDialog();
            setOpenPanel(false);

            if (itemsRevision.length > 1) {
              itemsRevision.forEach((data, index) => {
                formRevision.ListaVerificacionId.push(data.listaVerificacionId);
              });
            } else if (itemRevision.listaVerificacionId != "") {
              //console.log("1 Item");
              formRevision.ListaVerificacionId = [
                itemRevision.listaVerificacionId,
              ];
            }

            formRevision.Comentario = inputComentario;
            //setFormRevision(...formRevision);
            // console.log("formRevision");
            // console.log(formRevision);
            //setFormRevision(dataFormRevision);
            ListaVerificacionService.postRevisionMantenimiento(formRevision)
              .then((x) => {
                //setItems(x.data.items);
                toggleHideDialog();
                toggleHideDialogSuccess();
                //actualizar la grilla
                // loadTabla({ SoloCriticas: true });
                loadTabla(filter, { SoloCriticas: true });
              })
              .catch((error) => {
                toggleHideDialog();
                toggleHideDialogError();
                // loadTabla({ SoloCriticas: true });
                loadTabla(filter, { SoloCriticas: true });
              });
          }}
          styles={buttonStyles}
        >
          Revisar
        </PrimaryButton>
        <DefaultButton onClick={() => setOpenPanel(false)}>
          Cancelar
        </DefaultButton>
      </div>
    ),
    [itemRevision, itemsRevision, formRevision, inputComentario]
  );

  /* Event Filter */
  const _onChangeText = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setSearchParam({
        [baseSearch]: newValue,
      });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };

  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
    setFiltermx({
      ...filterMx,
      search: "",
    });
    setSearchParam({
      [baseSearch]: "",
    });
  };

  const _onPress = (newValue: string) => {
    if (newValue != undefined) {
      console.log(newValue);
      switch (tabIndex) {
        case "1":
          setFiltermx({
            ...filterMx,
            search: newValue,
          });
          break;
        case "2":
          setFilter({
            ...filter,
            search: newValue,
          });
          break;

        default:
          break;
      }

      console.log(newValue);
    }
  };

  const _getFilter = () => {
    return searchParam.get(baseSearch) ?? "";
  };

  useEffect(() => {
    switch (tabIndex) {
      case "1":
        loadTablaMx(filter, filterMxBody);
        break;
      case "2":
        loadTabla(filter, modelInForm);
        break;
      default:
        break;
    }
  }, [tabIndex]);

  const _onLinkClik = (
    item?: PivotItem,
    ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => {
    if (item != undefined) {
      let { itemKey } = item.props;
      if (itemKey != undefined) {
        setTabIndex(itemKey);
      }
    }
    // console.log(tabIndex)
  };
  const exeFilterMantenimiento = () => {
    let bodyFilter: IFilterChecklistMantenimiento = {
      ...modelInForm,

      SoloCriticas: true,
    };
    loadTabla(filter, bodyFilter);
  };

  const childToParent = (childdata) => {
    setModelInForm({ ...childdata });
    // console.log(childdata)
  };
  const itemsPageSize = (onChangePageSize) => {
    // setModelInForm({ ...onChangePageSize })
    // setPagIngreso({ ...pagIngreso, onSizeChange: () => setPageSize(onChangePageSize) })
    setPageSize(onChangePageSize);
    console.log(pageSize);
  };

  const clearFilterMantenimiento = () => {
    setModelInForm({ SoloCriticas: true });
    loadTabla(filter, { SoloCriticas: true });
    isOnFilterMantenimiento();

    setLimpiarPanelMantenimiento(true);
    setTimeout(() => {
      setLimpiarPanelMantenimiento(false);
    }, 1000)
  };


  const isOnFilterMantenimiento = () => {
    modelInForm?.equipoId !== undefined ||
      modelInForm?.equipoModeloId !== undefined ||
      modelInForm?.fecha !== undefined ||
      modelInForm?.supervisorId !== undefined ||
      modelInForm?.estadoId !== undefined ||
      modelInForm?.tipoEquipoId !== undefined
      ? setisFilterMantenimiento(true)
      : setisFilterMantenimiento(false);

    console.log("Filtrando : " + isFilterMantenimiento);
  };

  const closePanel = () => {
    dismissFiltros();
  };

  const closePanelMx = () => {
    dismissFiltrosMx();
  }
  const exeFilter = () => {
    loadTablaMx(filter, filterMxBody);
  };


  const limpiarFilters = () => {
    setFechaInicio(ObtenerFechaSegunLugar());
    setFechaFin(ObtenerFechaSegunLugar());
    setFilter({
      skip: 0,
      take: 50,
      search: null,
    });
    setFilterEquipos({
      skip: 0,
      take: 50,
      search: null,
    });
    limpiarFiltersModelos();
    setFiltermxBody({
      equipoModeloId: null,
      tipoEquipoId: null,
      equipoId: null,
      supervisorId: null,
      fecha: _formatDate(ObtenerFechaSegunLugar(), "/"),
      fechaFin: _formatDate(ObtenerFechaSegunLugar(), "/"),
    });
    // setFiltermxBody(undefined)
    setSearch("");
    setFilter({
      skip: 0,
      take: 50,
      search: null,
    });
    setisFilterMx(false);
    // loadTablaMx(filter, filterMxBody);
    setControl(true)
  };

  useEffect(() => {
    if (control) {
      loadTablaMx(filter, filterMxBody);
      setControl(false)
    }
  }, [control]);



  const _farItems: ICommandBarItemProps[] = [
    {
      key: "filter",
      text: `${isFilterMantenimiento ? "Limpiar Filtro" : "Buscar"}`,
      iconProps: {
        iconName: `${isFilterMantenimiento ? "clearfilter" : "filter"}`,
      },
      onRenderIcon() {
        return IconHelper.ICONFILTER;
      },
      onClick: openFiltros,
      disabled: tabIndex === "1" ? true : false,
    },
  ];
  const _farItemsMx: ICommandBarItemProps[] = [
    {
      key: "filtermx",
      text: `${isFilterMx ? "Limpiar Filtro" : "Buscar"}`,
      iconProps: { iconName: `${isFilterMx ? "clearfilter" : "filter"}` },
      onRenderIcon() {
        return IconHelper.ICONFILTER;
      },
      onClick: openFiltrosMx,
    },
  ];

  //CAPTURA DE TAMAÑO DE PAGINA
  const _getPageSize = (value: number) => {
    console.log("Tamaño de pagina : ", value);
    setPageSize(value);
    setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value });
    setPagIngreso({ ...pagIngreso, pageSize: value });
  };

  const _onkeyUpSearchSupervisor = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefSupervisores.current?.focus(false);
      setSearch("");
    } else {
      _openOptionSupervisores();
      let { value } = event?.target as HTMLInputElement;
      setSearch(value);
    }
  };

  const _openOptionSupervisores = useCallback(
    () => comboBoxRefSupervisores.current?.focus(true),
    []
  );
  const onClickComboSupervisores = () =>
    comboBoxRefSupervisores.current?.focus(true);


  const _onkeyUpSearchTipoEquipo = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefTipoEquipo.current?.focus(false);
      setFilterTipoEquipo({
        ...filterTipoEquipo,
        search: "",
      });
    } else {
      _openOptionTipoEquipo();
      let { value } = event?.target as HTMLInputElement;
      setFilterTipoEquipo({
        ...filterTipoEquipo,
        search: value,
      });
    }
  };

  const _openOptionTipoEquipo = useCallback(
    () => comboBoxRefTipoEquipo.current?.focus(true),
    []
  );
  const onClickComboTipoEquipo = () =>
    comboBoxRefTipoEquipo.current?.focus(true);

  const _onkeyUpSearchEquipo = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefEquipo.current?.focus(false);
      setFilterEquipos({
        ...filterEquipos,
        search: "",
      });
    } else {
      _openOptionEquipo();
      let { value } = event?.target as HTMLInputElement;
      setFilterEquipos({
        ...filterEquipos,
        search: value,
      });
    }
  };

  const _openOptionEquipo = useCallback(
    () => comboBoxRefEquipo.current?.focus(true),
    []
  );

  const onclickComboEquipo = () =>
    comboBoxRefEquipo.current?.focus(true);

  useEffect(() => {
    dataEquipos(filterEquipos);
  }, [filterEquipos]);

  useEffect(() => {
    ComboSupervisores(Search);
  }, [Search]);

  useEffect(() => {
    dataTipoEquipos(filterTipoEquipo);
  }, [filterTipoEquipo]);

  return (
    <div>
      <div>
        <HeadingBar
          title="Mantenimiento"
          subTitle=" Revisar Checklist con observaciones críticas"
          searchPlaceholder="Buscar Persona"
          searchChange={_onChangeText}
          searchHandler={_onPress}
          searchValue={_getFilter()}
          onClearHandler={_onClearSearch}
        ></HeadingBar>

        <Pivot
          styles={themeBase.pivotStyles}
          aria-label="Large Link Size Pivot Example"
          linkSize="large"
          selectedKey={tabIndex}
          onLinkClick={_onLinkClik}
        >
          <PivotItem headerText="Pendiente Sup. Mantto" itemKey="1" key={1}>
            <Stack>
              <TableBase
                leftBar={_items}
                rigthBar={_farItemsMx}
                data={itemsMX}
                selection={_selection}
                column={_columns}
                isLoading={!dataIsLoad}
                getPageSize={_getPageSize}
                layout={DetailsListLayoutMode.justified}
                pagination={pagIngreso2}
              />
            </Stack>

            {/* {(tabIndex === '1') &&
              <>
                {items.length > 0 && (<TagDefault bodyMenssaje={`Usted tiene ${total2} Checklist pendientes de revisión`} resetChoice={resetChoice} />)}
              </>
            } 
            {/* <div className="ms-Grid-col ms-sm12 ms-lg12">
              <CommandBar
                buttonAs={CustomButton}
                items={_items}
                farItems={_farItemsMx}
                styles={themeBase.commadStyles}
              />
            </div> */}

            {/* <MarqueeSelection selection={_selection}>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <LineProgress disabled={dataIsLoad} />
                <DetailsList
                  items={itemsMX}
                  compact={false}
                  columns={_columns}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selection={_selection}
                  selectionPreservedOnEmptyClick={true}
                  ariaLabelForSelectionColumn="Toggle selection"
                  ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                  checkButtonAriaLabel="select row"
                  styles={_onRenderHeader}
                />
              </div>
            </MarqueeSelection>  */}
            {/* <div>
              <PaginationFooter total={itemsMX.length} pagination={pagIngreso2}></PaginationFooter>
            </div> */}
          </PivotItem>

          <PivotItem headerText="Mantenimiento" itemKey="2" key={2}>
            <Stack>
              <TableBase
                leftBar={_itemsMantto}
                rigthBar={_farItems}
                data={items}
                column={_columns}
                isLoading={!dataIsLoad}
                getPageSize={(arg) => { }}
                pagination={pagIngreso}
              />
            </Stack>
            <div className="ms-Grid-col ms-sm12 ms-lg12"></div>
          </PivotItem>
        </Pivot>

        <Dialog
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={{
            title: "Enviando Información",
            type: DialogType.normal,
            subText: "Por favor espere un momento",
          }}
        >
          <ProgressIndicator barHeight={5} />
        </Dialog>
        <Dialog
          hidden={hideDialogSuccess}
          onDismiss={toggleHideDialogSuccess}
          dialogContentProps={{
            title: "Proceso Correcto",
            subText: "Su solicitud se procesó correctamente!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="Accept"
                style={{
                  color: theme.palette.themePrimary,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <PrimaryButton onClick={toggleHideDialogSuccess} text="Aceptar" />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={hideDialogError}
          onDismiss={toggleHideDialogError}
          dialogContentProps={{
            title: "Error en Solicitud",
            subText: "Hubo un problema con la información enviada!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="ErrorBadge"
                style={{
                  color: theme.palette.redDark,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <DefaultButton onClick={toggleHideDialogError} text="Aceptar" />
          </DialogFooter>
        </Dialog>

        <Panel
          isOpen={openPanel}
          //onDismiss={setOpenPanel(false)}
          onDismiss={() => setOpenPanel(false)}
          type={PanelType.medium}
          closeButtonAriaLabel="Close"
          headerText="Revision de Checklist"
          onRenderFooterContent={onRenderFooterContent}
          isFooterAtBottom={true}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              {itemRevision.listaVerificacionId != "" && (
                <Text variant="xLarge">
                  {itemRevision.modelo} {itemRevision.equipo}
                </Text>
              )}
              {itemsRevision.length > 0 && (
                <Text variant="xLarge">
                  Revisar los siguientes {itemsRevision.length} equipos:
                </Text>
              )}
            </div>
          </div>
          {itemsRevision.length > 0 && (
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          )}
          <div className="ms-Grid" dir="ltr">
            {itemsRevision.map(function (object, i) {
              return (
                <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg4">
                  <Text variant="large">{object.equipo}</Text>
                </div>
              );
            })}
          </div>
          {itemDetalleListaVerificacion.listaVerificacionId != "" && (
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <Text variant="medium" className="ms-fontWeight-bold">
                  Persona<br></br>
                </Text>
                <Text variant="large">
                  {itemDetalleListaVerificacion.persona}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <Text variant="medium" className="ms-fontWeight-bold">
                  Fecha<br></br>
                </Text>
                <Text variant="large">
                  {itemDetalleListaVerificacion.fecha}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Observaciones</Text>
              </div>
              {itemDetalleListaVerificacion.observaciones.map(function (
                data,
                index
              ) {
                return (
                  <div key={index}>
                    <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10">
                      {data.codigoOpcion == "02" && (
                        <Icon
                          iconName="WarningSolid"
                          color={theme.palette.redDark}
                          style={{ color: theme.palette.redDark }}
                        ></Icon>
                      )}
                      {data.codigoOpcion == "03" && (
                        <Icon
                          iconName="WarningSolid"
                          color={theme.palette.black}
                          style={{ color: theme.palette.black }}
                        ></Icon>
                      )}
                      &nbsp;
                      <Text variant="smallPlus">
                        {data.propiedadVerificacion}
                      </Text>
                    </div>
                    <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2">
                      <Text variant="smallPlus" className="ms-fontWeight-bold">
                        {data.opcion}
                      </Text>
                    </div>
                  </div>
                );
              })}
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Comentario</Text>
                <br></br>
                <Text className="ms-fontWeight-semiBold">
                  {itemDetalleListaVerificacion.comentario}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Fotos</Text>
              </div>
              {itemDetalleListaVerificacion.fotos.map(function (datos, indice) {
                return (
                  <div
                    key={indice}
                    className="ms-Grid-col ms-sm4 ms-md4 ms-lg4"
                  >
                    <Image
                      src={datos}
                      styles={{
                        root: {
                          border: "0px solid " + theme.palette.neutralSecondary,
                        },
                      }}
                      height={150}
                      imageFit={ImageFit.contain}
                      onClick={showModal}
                    ></Image>
                    <Modal
                      titleAriaId={"titleId"}
                      isOpen={isModalOpen}
                      onDismiss={hideModal}
                      isBlocking={false}
                    >
                      <Image
                        src={datos}
                        styles={{
                          root: {
                            border:
                              "0px solid " + theme.palette.neutralSecondary,
                          },
                        }}
                        height={650}
                        imageFit={ImageFit.contain}
                      ></Image>
                    </Modal>
                  </div>
                );
              })}
            </div>
          )}
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          <Separator>
            {"Verifique las opciones, luego click en revisar"}
          </Separator>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid">
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <ChoiceGroup
                  label="Seleccione actividad a realizar"
                  defaultSelectedKey="taller"
                  options={optionsActividad}
                />
              </div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <ChoiceGroup
                  label="Seleccione inspección realizada"
                  defaultSelectedKey="no"
                  options={optionsInspeccion}
                />
              </div>
            </div>

            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <TextField
                label="Comentario"
                multiline
                resizable={false}
                onChange={(x, y) => setInputComentario(x.currentTarget.value)}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          </div>
        </Panel>

        {/* PANEL PDF ADJUNTO*/}
        {/* <TelerikMantenimiento
          isOpen={isOpenAdjunto}
          onDismiss={dismissAdjunto}
          formatos={1}
          reportName="ListaVerificacion.trdx"
          parametros={{
            listaVerificacionId: itemSelect?.listaVerificacionId ? itemSelect?.listaVerificacionId : ""
          }}
        /> */}
        <PanelGenerico
          isOpen={isOpenAdjunto}
          onDismiss={dismissAdjunto}
          enabledFooter={true}
          panelType={PanelType.large}
          enabledHeader
          title="Adjunto Mantenimiento Checklist"
          subTitle={`${itemSelect?.modelo} - ${itemSelect?.equipo}`}
        >
          <div style={themeBase._padding20}>
            {/* <BaseTelelirk
              viewMode={ETelerikViewmode.PRINT_PREVIEW}
              reportName="ListaVerificacion.trdx"
              parametros={{
                listaVerificacionId: itemSelect?.listaVerificacionId,
              }}
            />
            Report 02 */}
            <BaseTelerikV1
              // viewMode={"PRINT_PREVIEW"}
              reportName="ListaVerificacion.trdx"
              parametros={{
                listaVerificacionId: itemSelect?.listaVerificacionId,
              }}
              viewMode={EViewMode.PRINT_PREVIEW}
            />
          </div>
        </PanelGenerico>
        {/* PANEL DE FILTRO PERSONALIZADO*/}
        <PanelGenerico
          onRenderHeader={onRenderHeaderMantenimiento}
          isOpen={isOpenFiltros}
          onDismiss={closePanel}
          cancelar={clearFilterMantenimiento}
          registrar={exeFilterMantenimiento}
          textRegister="Buscar"
          textCancel="Limpiar"
          objectRenderBodyHelp={filterMxBody}
          enabledHeader
        >
          <FilterMantenimiento
            isOpen={isOpenFiltros}
            formData={modelInForm}
            childToParent={childToParent}
            pivot={tabIndex}
            limpiarFiltros={limpiarPanelMantenimiento}
          />
        </PanelGenerico>

        {/* PANEL DE FILTRO PERSONALIZADO MX*/}
        <PanelGenerico
          onRenderHeader={onRenderHeaderPanel}
          isOpen={isOpenFiltrosMx}
          onDismiss={closePanelMx}
          cancelar={limpiarFilters}
          registrar={exeFilter}
          textRegister="Buscar"
          textCancel="Limpiar"
          enabledHeader
          objectRenderBodyHelp={filterMxBody}
        >
          <br />

          <div className="ms-Grid" dir="ltr">
            <Stack tokens={themeBase.StackTokens20}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                  <DatePicker
                    label="Fecha Inicio"
                    placeholder="dd/mm/yyyy"
                    ariaLabel="Seleccione una fecha"
                    onSelectDate={setFechaInicio as (date?: any) => void}
                    formatDate={formatDate_DDMMYY}
                    strings={defaultDatePickerStrings}
                    value={fechaInicio}
                    maxDate={new Date()}
                    borderless
                    style={{ borderBottom: "solid 1px blue" }}
                  />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                  <DatePicker
                    label="Fecha Fin"
                    placeholder="dd/mm/yyyy"
                    ariaLabel="Seleccione una fecha"
                    onSelectDate={setFechaFin as (date?: any) => void}
                    formatDate={formatDate_DDMMYY}
                    strings={defaultDatePickerStrings}
                    value={fechaFin}
                    minDate={fechaInicio}
                    maxDate={new Date()}
                    borderless
                    style={{ borderBottom: "solid 1px blue" }}
                    disabled={fechaInicio != undefined ? false : true}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <ComboBox
                    label="Supervisor"
                    // text={filterAvanzado?.supervisorId ? SupervisoresCombo.find((x) => x.key === filterAvanzado?.supervisorId)?.text : ""}
                    componentRef={comboBoxRefSupervisores}
                    onKeyUp={_onkeyUpSearchSupervisor}
                    options={SupervisoresCombo}
                    allowFreeform
                    autoComplete="off"
                    onChange={_onChangeSupervisor}
                    selectedKey={filterMxBody ? filterMxBody.supervisorId : ""}
                    onClick={onClickComboSupervisores}
                    onRenderOption={(option) => (
                      <>
                        {option && (
                          <div>
                            <span>{option?.text}</span>
                            <br />
                            <span
                              style={{
                                paddingBottom: "0.9px",
                                color: "#777",
                                fontSize: "0.7rem",
                              }}
                            ></span>
                          </div>
                        )}
                      </>
                    )}
                    // disabled
                    useComboBoxAsMenuWidth
                    styles={{ optionsContainer: { maxHeight: 200 } }}
                  />
                </div>
              </div>
              {/* <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <ComboBox
                    label="Supervisor"
                    options={[]}
                    allowFreeform
                    // onChange={_onChangeSupervisor}
                    // selectedKey={filterAvanzado?.supervisorId}
                    // disabled
                    useComboBoxAsMenuWidth
                    disabled
                    styles={{ optionsContainer: { height: 200 } }}
                  />
                </div>
              </div> */}
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6 ms-lg12">
                  <ComboBox useComboBoxAsMenuWidth
                    allowFreeform
                    // calloutProps={{ directionalHintFixed: true }}
                    // scrollSelectedToTop
                    onKeyUp={_onkeyUpSearchTipoEquipo}
                    autoComplete="off"
                    label="Tipo Equipo"
                    options={tipoEquipo}
                    componentRef={comboBoxRefTipoEquipo}
                    onChange={_onChangeTipoEquipo}
                    onClick={onClickComboTipoEquipo}
                    styles={{ optionsContainer: { maxHeight: 200 } }}
                    selectedKey={filterMxBody ? filterMxBody.tipoEquipoId : ""}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6 ms-lg6">
                  <ComboBox
                    useComboBoxAsMenuWidth
                    allowFreeform
                    // calloutProps={{ directionalHintFixed: true }}
                    // scrollSelectedToTop
                    autoComplete="off"
                    onKeyUp={_onkeyUpSearchDispositivo}
                    label="Modelos de Equipos"
                    options={dataComboModelos}
                    componentRef={comboBoxRefModelos}
                    onChange={_onChangeModelos}
                    onClick={onClickComboModelos}
                    selectedKey={filterMxBody ? filterMxBody.equipoModeloId : ""}
                    styles={{ optionsContainer: { maxHeight: 200 } }}

                  />
                </div>
                <div className="ms-Grid-col ms-sm6 ms-lg6">
                  <ComboBox
                    useComboBoxAsMenuWidth
                    allowFreeform
                    // calloutProps={{ directionalHintFixed: true }}
                    // scrollSelectedToTop
                    autoComplete="off"
                    onKeyUp={_onkeyUpSearchEquipo}
                    label="Equipo"
                    options={equipos}
                    componentRef={comboBoxRefEquipo}
                    onChange={_onChangeEqipos}
                    onClick={onclickComboEquipo}
                    selectedKey={filterMxBody ? filterMxBody.equipoId : ""}
                    styles={{ optionsContainer: { maxHeight: 200 } }}
                  />
                </div>
              </div>
            </Stack>
          </div>
        </PanelGenerico>

        {/* PANEL FOTOS */}
        <FotosMantenimiento
          ulrFostos={fotosRutas}
          isOpen={isOpenFotosChecklist}
          dismiss={dismissFotosChecklist}
        />
      </div>
    </div>
  );
}

export default ListaVerificacionMantenimiento;

// const _titlesPanleFilter: IHeaderTitlesText = {
//   title: "Filtro Personalizado",
//   subTitle: "Elija las condiciones para el filtro personalizado",
// };

const PanelGenericoProps: IpanelGeneric = {
  // HeaderTitlesText: _titlesPanleFilter,
  textCancel: "Limpiar",
  textRegister: "Filtrar",
};
export interface IFilterListaVerificacion {
  equipoModeloId?: string | null;
  tipoEquipoId?: string | null;
  equipoId?: string | null;
  estadoId?: string | null;
  fechaInicio?: string | null;
  fechaFin?: string | null;
}

export interface IFilterPendienteMx {
  equipoModeloId?: string | null;
  tipoEquipoId?: string | null;
  equipoId?: string | null;
  fecha?: string | null;
  fechaFin?: string | null;
  supervisorId?: string | null;
}

